import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { DropdownMultiselectItem } from '@bayclubs/drop-down';

import { FilterApiService } from '../../../../services/api/filter-api.service';

import { FilterDropDownsService } from '../../../../services/filter-dropdowns.service';
import { CampManagementFilter } from '../../../../models/filters/camp-management-filter.model';

@Component({
    selector: 'app-camp-search-criteria',
    templateUrl: './camp-search-criteria.component.html',
    styleUrls: ['./camp-search-criteria.component.scss'],
    standalone: false
})
export class CampSearchCriteriaComponent implements OnInit {
    @Input()
    public searchForm: UntypedFormGroup;

    public clubDropdownItems: DropdownMultiselectItem[] = [];
    public categoriesDropdownItems: DropdownMultiselectItem[] = [];
    public campTypeDropdownItems: DropdownMultiselectItem[] = [];

    public isBusy: boolean = true;

    @Input() public filters: CampManagementFilter;

    constructor(
        private filtersApi: FilterApiService,
        private filterDropDownsService: FilterDropDownsService
    ) {}

    ngOnInit() {
        this.isBusy = true;
        this.loadFilters();
    }

    private loadFilters() {
        this.filtersApi.get(false).subscribe(data => {
            if (data.isSuccess) {
                this.clubDropdownItems = this.filterDropDownsService.createClubDropDownItemsWithCode(
                    data.value,
                    this.filters.clubCodes
                );
                this.categoriesDropdownItems = this.filterDropDownsService.createCategoriesDropDownItems(
                    data.value,
                    this.filters.categories
                );
                this.campTypeDropdownItems = this.filterDropDownsService.createCampTypeDropDownItems(this.filters.campTypes);
            }

            this.isBusy = false;
        });
    }

    public onClubsChanged(data: Array<DropdownMultiselectItem>) {
        const clubCodes = data.map(x => x.id);
        this.searchForm.controls['clubCodes'].setValue(clubCodes);
    }

    public onCategoryChanged(data: Array<DropdownMultiselectItem>) {
        const categories = data.map(x => x.id);
        this.searchForm.controls['categories'].setValue(categories);
    }

    public onCampTypeChanged(data: Array<DropdownMultiselectItem>) {
        const campTypes = data.map(x => x.id);
        this.searchForm.controls['campTypes'].setValue(campTypes);
    }
}
